import {ReactElement} from "react";
import {useNavigate} from "react-router-dom";
import styled from "styled-components";

import Logo from "@/assets/logo.svg?react";
import TextLogo from "@/assets/textLogo.svg?react";
import {breakpoints, quicksandSemiBold} from "@/GlobalStyle";

const FooterStyled = styled.footer`
  height: 70px;
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  overflow: hidden;
`;
const FooterLeftStyled = styled.div`
  flex: 1;
  background-color: ${({theme}) => theme.colors.darkPrimary};
  transform: skew(20deg);
  margin: 0 0 0 -15px;
`;
const FooterRightStyled = styled(FooterLeftStyled)`
  background-color: ${({theme}) => theme.colors.mediumSecondary};
  margin: 0 -15px 0 0;
  transform: skew(20deg);
`;

const LogoContainerStyled = styled.div`
  width: 25%;
  min-width: 200px;
  background-color: white;
  transform: skew(20deg);
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  container-type: inline-size;
  container-name: footer_Container;
  @media (max-width: ${breakpoints.md}) {
    gap: 10px;
  }
`;

const LogoElementStyled = styled(Logo)`
  transform: skew(-20deg);
  height: 3.125rem;
  @container footer_Container (width < ${breakpoints.md}) {
    height: 2.5rem;
  }
`;

const TextLogoElementStyled = styled(TextLogo)`
  transform: skew(-20deg);
  height: 2.5rem;
  @container footer_Container (width < ${breakpoints.md}) {
    height: 1.5625rem;
  }
`;
const RgpdBlockStyled = styled.div`
  width: 100%;
  padding: 15px 0;
  border-top: 3px solid ${({theme}) => theme.colors.mediumSecondary};

  & p {
    text-align: center;
    color: ${({theme}) => theme.colors.darkPrimary};
    ${quicksandSemiBold}
    a {
      color: ${({theme}) => theme.colors.mediumSecondary};
      text-decoration: underline;
      ${quicksandSemiBold}
      &:hover {
        cursor: pointer;
      }
    }
  }
`;

export function Footer(): ReactElement {
  const navigate = useNavigate();
  return (
    <>
      <RgpdBlockStyled>
        <p>
          Gestion des données personnelles <span aria-hidden="true">→</span>{" "}
          <a onClick={() => navigate("/rgpd")}>RGPD</a>
        </p>
      </RgpdBlockStyled>
      <FooterStyled>
        <FooterLeftStyled />
        <LogoContainerStyled>
          <LogoElementStyled />
          <TextLogoElementStyled />
        </LogoContainerStyled>
        <FooterRightStyled />
      </FooterStyled>
    </>
  );
}
